module.exports = __webpack_public_path__ + "img/shop_btn1.2e00dd6d.png";